module.exports = __webpack_public_path__ + "img/worksbot_img19112538.54a2d14e.jpg";